import Vue from 'vue'
import App from './App.vue'
import './assets/css/base.css'
import Distpicker from 'v-distpicker'
import router from './router/router'
import './tools/'
import './api/index'
import store from './store/store'
import ElementUI from 'element-ui'
import '../element-variables.scss'
import './assets/icon/iconfont.css'
import editor from 'medium-editor'
import './config/init'
import 'medium-editor/dist/css/medium-editor.min.css'
import 'medium-editor/dist/css/themes/default.min.css'
// import 'element-ui/lib/theme-chalk/index.css'
import  plugin from './plugin/index'

Vue.component('v-distpicker', Distpicker)
Vue.use(ElementUI)
Vue.use(plugin)

Vue.config.productionTip = false
Vue.prototype.$editor = editor
Vue.prototype.$messageSuccess = function (msg) {
  this.$message({type:'success',message: msg,duration:1000})
}
Vue.prototype.$messageError = function (msg) {
  this.$message({type:'error',message: msg,duration:1000})
}
const vue =  new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
export default vue